"use strict";
import { isValidEmail } from "./helpers";
import swal from 'sweetalert2';

$(document).ready(function () {

    $('.utc-date').each(function () {
        $(this).text(moment($(this).text()).format('LLL'));
    });

    $(".moment-transform").each(function () {
        $(this).text(moment($(this).text()).format('MMMM DD, YYYY - dddd'));
    });

    if (window.location.href.indexOf('/users') !== -1) {
        getUsers();
    }
    
    if (window.location.href.indexOf('/inquiries') !== -1) {
        getInquiries();
    }
    
    evtSubmitAddEditUserForm();
    evtModal();
    evtButtons();

    saveModalOriginalHTML();
    
    function postAddEditUserForm(objFormData) {
        var user_id = objFormData.id || "new";
        return $.post("/api/v1/user/" + user_id, objFormData);
    }

    function saveModalOriginalHTML() {
        $(".modal").each(function () {
            $(this).data("originalHTML", $(this).html());
        });
    }

    function resetModal($modal) {
        if(!$modal) return false;

        var $selectPicker = $modal.find('.selectpicker');
        if ($selectPicker.length) {
            $selectPicker.selectpicker('destroy');
        }

        var originalHTML = $modal.data("originalHTML");
        if (!originalHTML) return false;

        $modal.html(originalHTML);
    }
    
    function evtSubmitAddEditUserForm() {
        $(document).on("submit", "[name='add_user'], [name='edit_user']", function(e) {
            e.preventDefault();
            
            var $form = $(this);
            var $modalUser = $(this).parents(".modal");
            var $btn = $form.find("[type='submit']");

            var objFormData = $form.serializeObject();
            var invalid = 0;

            $btn.button("loading");

            // clear alerts and invalid messages
            $form.find(".alert").hide();
            $form.find(".is-invalid").removeClass("is-invalid");

            $.each(objFormData, function (name, value) {
                if (name === 'can_only_access') return true;

                objFormData[name] = value.trim();

                if(name == "email") {
                    if (!isValidEmail(value)) {
                        $form.find("[name=" + name + "]").addClass("is-invalid");
                        invalid++;
                    }
                }
                else if(value.trim() == "") {
                    var ignore = objFormData.id && name == "password";
                    if(!ignore) {
                        $form.find("[name=" + name + "]").addClass("is-invalid");
                        invalid++;
                    }
                }
            });

            if(invalid > 0) {
                $btn.button("reset");
                return false;
            }

            postAddEditUserForm(objFormData)
                .done(function (response) {
                    if(response && response.status == 200) {
                        swal("Success!", response.message, 'success');
                        
                        if (objFormData.id) {
                            var $userRow = $("#" + objFormData.id);
                            $userRow.data("details", response.data);
                            updateUserRow($userRow);
                        } else {
                            addUserToList(response.data, "prepend");
                        }

                        $modalUser.modal("hide");
                        resetModal($modalUser);
                    }
                })
                .fail(function(err) {
                    if(!$.isEmptyObject(err.responseJSON)) {
                        if(err.responseJSON.message) {
                            $form.find(".alert > .message").text(err.responseJSON.message)
                            $form.find(".alert").show();
                        }
                    }
                })
                .always(function (response) {
                    $btn.button("reset");
                });
        });
    }

    function formatUserRow(user) {
        var access = (user.can_only_access || []).length > 0 ? user.can_only_access.join(', ').escapeHTML() : 'All Pages';
        return "<tr id='" + user.id + "'>\
                    <td>" + moment(user.created).format("lll") + "</td>\
                    <td>" + user.name.escapeHTML() + "</td>\
                    <td>" + user.username.escapeHTML() + "</td>\
                    <td>" + user.email.escapeHTML() + "</td>\
                    <td>" + access + "</td>\
                    <td>\
                        <button type='button' class='btn btn-success' data-toggle='modal' data-target='#modalEditUser'>Edit</button>\
                        <button type='button' class='btn btn-danger js-delete-user'>Delete</button>\
                    </td>\
                </tr>";
    }

    function addUserToList(user, order) {
        if(!order) order = "append";
        var $userRow = $(formatUserRow(user));
        
        $userRow.data("details", user);
        $userRow.find(".js-delete-user").data("id", user.id);

        if(order == "append") {
            $(".js-user-list tbody").append($userRow);
        } else {
            $(".js-user-list tbody").prepend($userRow);
        }
    }

    function updateUserRow($userRow) {
        var user = $userRow.data("details");
        var $newUserRow = $(formatUserRow(user));

        $newUserRow.data("details", user);
        $newUserRow.find(".js-delete-user").data("id", user.id);

        $userRow.replaceWith($newUserRow);
    }

    function getUsers(cursor) {
        var params = {};
        if(cursor) params["cursor"] = cursor;

        return $.get("/api/v1/users", params, function (response) {
            if(response.data && response.data.length) {
                if (!cursor) $(".js-user-list tbody").empty();

                response.data.forEach(function (u) {
                    addUserToList(u);
                });
            }

            if(response.cursor) {
                $(".js-user-list tfoot .js-load-users").val(response.cursor);
                $(".js-user-list tfoot").show();
            } else {
                $(".js-user-list tfoot .js-load-users").val("");
                $(".js-user-list tfoot").hide();
            }
        });
    }

    function formatInquiryRow(inquiry) {
        return "<tr id='" + inquiry.id + "'>\
                    <td class='w15p'>" + moment(inquiry.created).format("lll") + "</td>\
                    <td class='w15p'>\
                        <strong>Name</strong>\
                        <p>" + inquiry.name.escapeHTML() + "</p>\
                        <strong>Contact No.</strong>\
                        <p>" + (inquiry.contact_num || "").escapeHTML() + "</p>\
                        <strong>Email</strong>\
                        <p>" + inquiry.email.escapeHTML() + "</p>\
                    </td>\
                    <td class='w20p'>" + inquiry.subject.escapeHTML() + "</td>\
                    <td class='w40p'>" + inquiry.message.escapeHTML() + "</td>\
                    <td class='w10p'>\
                        <a href='mailto:" + inquiry.email + "?Subject=Re: " + inquiry.subject + "' class='btn btn-success btn-block mb5'>Reply</a>\
                        <button type='button' class='d-none btn btn-light btn-block js-inquire-resolve'>Mark Resolve</button>\
                    </td>\
                </tr>";
    }

    function addInquiryToList(inquiry) {
        var $inquiryRow = $(formatInquiryRow(inquiry));
        $inquiryRow.data("details", inquiry);
        $(".js-inquiry-list tbody").append($inquiryRow);
        
    }

    function getInquiries(cursor) {
        var params = {};
        if (cursor) params["cursor"] = cursor;

        return $.get("/api/v1/inquiries", params, function (response) {
            if (response.data && response.data.length) {
                if (!cursor) $(".js-inquiry-list tbody").empty();
                response.data.forEach(function (i) {
                    addInquiryToList(i);
                });
            }

            if (response.cursor) {
                $(".js-inquiry-list tfoot .js-load-inquiries").val(response.cursor);
                $(".js-inquiry-list tfoot").show();
            } else {
                $(".js-inquiry-list tfoot .js-load-inquiries").val("");
                $(".js-inquiry-list tfoot").hide();
            }
        });
    }

    function deleteUser(params) {
        return $.post("/api/v1/user/delete", params);
    }

    function evtButtons() {
        $(document).on("click", ".js-delete-user", function () {
            var $btn = $(this);
            var id = $(this).data("id");

            swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    deleteUser({id: id}).then(function (response) {
                        if(response.status == 200) {
                            swal('Deleted!', response.message, 'success');
                            $btn.parents("tr").remove();
                        }
                    });
                }
            })
        });

        $(document).on("click", ".js-load-users", function () {
            var $btn = $(this);

            $btn.button("loading");
            getUsers($(this).val()).then(function () {
                $btn.button("reset");
            });
        });

        $(document).on("click", ".js-load-inquiries", function() {
            var $btn = $(this);

            $btn.button("loading");
            getInquiries($(this).val()).then(function () {
                $btn.button("reset");
            });
        });
    }

    function evtModal() {
        $("#modalEditUser").on('show.bs.modal', function (e) {
            var $modal = $(this);
            var userDetails = $(e.relatedTarget).parents("tr").data("details");
            $.each(userDetails, function (k, v) {
                // if (k === 'can_only_access') {
                //     $("#ecanAccess").selectpicker('refresh');
                // } else {
                    var $field = $modal.find("[name=" + k + "]");
                    if($field.length) $field.val(v);
                    
                // }
                
            });

            $("#ecanAccess").selectpicker('refresh');
        });
    }
});